<template>
  <PrintPage :pageNumber="pageNumber">
    <template v-slot:header>
      <slot>
        <PrintHeaderSSPSlim />
      </slot>
    </template>

    <div class="content-box">
      <div class="content-box-header">
        <h2>2. {{ $t('brickAndUk') }}</h2>
      </div>
      <div class="two-column-grid">
        <div>{{ $t('brickAndUkAssemblyType') }}</div>
        <div>{{ $t(project.enpalReport.brickAndUkAssemblyType) }}</div>
      </div>
    </div>

    <AttachmentsPrintGrid
      :attachments="project.brickCoverWidthAttachments"
      fieldName="brickCoverWidthAttachments"
      :maxImages="2"
    />

    <AttachmentsPrintGrid
      :attachments="project.correctBrickHandlingAttachments"
      fieldName="correctBrickHandlingAttachments"
      :maxImages="2"
    />

    <div class="content-box">
      <div class="two-column-grid">
        <div>{{ $t('brickAndUkA2State') }}</div>
        <div>{{ $t(project.enpalReport.brickAndUkA2State) }}</div>
        <div>{{ $t('brickAndUkBState') }}</div>
        <div>{{ $t(project.enpalReport.brickAndUkBState) }}</div>
      </div>
    </div>

    <AttachmentsPrintGrid
      :attachments="project.brickAndSubstructureAttachments"
      fieldName="brickAndSubstructureAttachments"
      :maxImages="2"
    />

    <div class="content-box">
      <div class="two-column-grid">
        <div>{{ $t('cableAndPlugAttachedToRailState') }}</div>
        <div>{{ $t(project.enpalReport.cableAndPlugAttachedToRailState) }}</div>
      </div>
    </div>
  </PrintPage>
</template>

<script>
import PrintPage from '@/components/Print/PrintPage';
import PrintHeaderSSPSlim from '@/components/Print/PrintHeaderSSPSlim';
import AttachmentsPrintGrid from '@/components/Print/AttachmentsPrintGrid';
import { range } from '@/helpers/math.js';

export default {
  name: 'MeasurementPrintPage1',
  components: {
    PrintPage,
    PrintHeaderSSPSlim,
    AttachmentsPrintGrid,
  },
  props: {
    project: null,
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },
  computed: {},
  methods: { range },
};
</script>
